import { buildCampaignContactWhatsappLink } from '@/pages/IndexPage/legalPrimeLanding/content/indexLandingContent'
import { safePublicHttpHref } from '@/lib/public-href'

function buildWhatsappHrefFromPhone(phoneDigits: string, message: string): string {
  const encoded = encodeURIComponent(message)
  return `https://api.whatsapp.com/send/?phone=${phoneDigits}&text=${encoded}&type=phone_number&app_absent=0`
}

function extractPhoneDigits(value: string): string | null {
  const digits = value.replace(/\D/g, '')
  if (digits.length < 10) {
    return null
  }

  return digits
}

function isWhatsappUrl(value: string): boolean {
  return /whatsapp|wa\.me/i.test(value)
}

function isHttpUrl(value: string): boolean {
  return /^https?:\/\//i.test(value)
}

export function resolveCampaignContactWhatsappHref(options: {
  contactValue: string | null | undefined
  campaignTitle: string
  whatsappButtonUrl?: string | null
  institutionPhone?: string | null
}): string {
  const campaignTitle = options.campaignTitle.trim() || 'esta campanha'
  const message = `Olá! Tenho dúvidas sobre o sorteio ${campaignTitle}.`
  const contactValue = options.contactValue?.trim()

  if (contactValue) {
    if (isWhatsappUrl(contactValue)) {
      return contactValue
    }

    if (isHttpUrl(contactValue)) {
      return contactValue
    }

    const phoneDigits = extractPhoneDigits(contactValue)
    if (phoneDigits) {
      return buildWhatsappHrefFromPhone(phoneDigits, message)
    }
  }

  const whatsappButtonUrl = safePublicHttpHref(options.whatsappButtonUrl)
  if (whatsappButtonUrl) {
    return whatsappButtonUrl
  }

  const institutionPhone = options.institutionPhone?.trim()
  if (institutionPhone) {
    const phoneDigits = extractPhoneDigits(institutionPhone)
    if (phoneDigits) {
      return buildWhatsappHrefFromPhone(phoneDigits, message)
    }
  }

  return buildCampaignContactWhatsappLink(campaignTitle)
}
